export default function Chess() {
  return (
    <main>
      <div className="chess">
        <p>Chess (cs246 final project)</p>
      </div>
    </main>
  );
}
